import logo from "./logo.svg";
import "./App.css";
import HomePage from "./pages/HomePage";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Routes, Route } from "react-router-dom";
import AboutUsPage from "./pages/AboutUsPage";
import ProductsPages from "./pages/ProductsPages";
import ProductDetailsPage from "./pages/ProductDetailsPage";
import Services from "./pages/Services";
import Industries from "./pages/Industries";
import Contact from "./pages/Contact";
import ScrollToTop from "./components/ScrollToTop";
function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/products" element={<ProductsPages />} />

        <Route path="/products/:slug" element={<ProductDetailsPage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
